<c-toaster id="tost-row" [placement]="position" class="p-3" position="fixed">
  @for (toast of toasts(); track trackByToastId($index, toast)) {
    <c-toast
      [ngClass]="toast.className"
      (timer)="onTimerChange($event, toast.id)"
      (visibleChange)="onVisibleChange($event, toast.id)"
      [visible]="toast.visible"
      [style.direction]="direction"
    >
      <c-toast-header class="toast-header">
        {{ toast.header }}
      </c-toast-header>
      <c-toast-body>
        <p>{{ toast.body }}</p>
        <c-progress thin [value]="toast.percentage" />
      </c-toast-body>
    </c-toast>
  }
</c-toaster>
